export const OfferExternalDocumentTypes = {
  DOCUMENTS_EXTERNAL_COMMERCIAL_PROPOSAL: 'DOCUMENTS_EXTERNAL_COMMERCIAL_PROPOSAL',
  DOCUMENTS_EXTERNAL_COMMERCIAL_DEVIATION: 'DOCUMENTS_EXTERNAL_COMMERCIAL_DEVIATION',
  DOCUMENTS_EXTERNAL_COVER_LETTER: 'DOCUMENTS_EXTERNAL_COVER_LETTER',
  DOCUMENTS_EXTERNAL_TECHNICAL_PROPOSAL: 'DOCUMENTS_EXTERNAL_TECHNICAL_PROPOSAL',
  DOCUMENTS_SIGNED_COMMERCIAL_PROPOSAL: 'DOCUMENTS_SIGNED_COMMERCIAL_PROPOSAL',
  DOCUMENTS_EXTERNAL_NDA: 'DOCUMENTS_EXTERNAL_NDA',
  DOCUMENTS_EXTERNAL_OTHERS: 'DOCUMENTS_EXTERNAL_OTHERS',
}

export const OfferInternalDocumentTypes = {
  DOCUMENTS_INTERNAL_COSTSHEET: 'DOCUMENTS_INTERNAL_COSTSHEET',
  DOCUMENTS_INTERNAL_DAMEXE: 'DOCUMENTS_INTERNAL_DAMEXE',
  DOCUMENTS_INTERNAL_ECC_SUPPORTING: 'DOCUMENTS_INTERNAL_ECC_SUPPORTING',
  DOCUMENTS_INTERNAL_PSS: 'DOCUMENTS_INTERNAL_PSS',
  DOCUMENTS_INTERNAL_OCC: 'DOCUMENTS_INTERNAL_OCC',
  DOCUMENTS_INTERNAL_LOA: 'DOCUMENTS_INTERNAL_LOA',
  DOCUMENTS_INTERNAL_CONTRIBUTOR_COMMENTS: 'DOCUMENTS_INTERNAL_CONTRIBUTOR_COMMENTS',
  DOCUMENTS_INTERNAL_INSURANCE_COMMENTS: 'DOCUMENTS_INTERNAL_INSURANCE_COMMENTS',
  DOCUMENTS_INTERNAL_BOND_COMMENTS: 'DOCUMENTS_INTERNAL_BOND_COMMENTS',
  DOCUMENTS_INTERNAL_LEGAL_STATEMENT: 'DOCUMENTS_INTERNAL_LEGAL_STATEMENT',
  DOCUMENTS_INTERNAL_LEGAL_COMMENTS: 'DOCUMENTS_INTERNAL_LEGAL_COMMENTS',
  DOCUMENTS_INTERNAL_IPR_CHECKLIST: 'DOCUMENTS_INTERNAL_IPR_CHECKLIST',
  DOCUMENTS_INTERNAL_TRR_REPORT: 'DOCUMENTS_INTERNAL_TRR_REPORT',
  DOCUMENTS_INTERNAL_OTHERS: 'DOCUMENTS_INTERNAL_OTHERS',
}

export const OfferTenderDocumentTypes = {
  DOCUMENTS_TENDER_FILE: 'DOCUMENTS_TENDER_FILE',
  DOCUMENTS_TENDER_QUERIES: 'DOCUMENTS_TENDER_QUERIES',
}

export const OfferSourcingDocumentTypes = {
  SOURCING_INTERNAL_DOCUMENT: 'SOURCING_INTERNAL_DOCUMENT',
  SOURCING_ANNEX: 'SOURCING_ANNEX',
  SOURCING_FRAME_AGREEMENT: 'SOURCING_FRAME_AGREEMENT',
  SOURCING_GCPR_BUYNOW: 'SOURCING_GCPR_BUYNOW',
  SOURCING_GCPR_LICENSE_FILE: 'SOURCING_GCPR_LICENSE_FILE',
}

export const OfferBookingDocumentTypes = {
  BOOKING_COSTSHEET: 'OFFER_BOOKING_COSTSHEET',
  BOOKING_CONFIRMATION_DOCUMENT: 'BOOKING_CONFIRMATION_DOCUMENT',
  BOOKING_SUPPORT_DOCUMENT: 'BOOKING_SUPPORT_DOCUMENT',
  BOOKING_NEW_SUPPORT_DOCUMENT: 'BOOKING_NEW_SUPPORT_DOCUMENT',
  BOOKING_COMMERCIAL_ATTACHMENT: 'BOOKING_COMMERCIAL_ATTACHMENT',
}

export const OfferVendorDocumentTypes = {
  VENDOR_QUOTATION: 'VENDOR_QUOTATION',
  VENDOR_QUOTE_DETAIL: 'VENDOR_QUOTE_DETAIL',
}

export const OfferDocumentTypes = {
  ...OfferExternalDocumentTypes,
  ...OfferInternalDocumentTypes,
  ...OfferTenderDocumentTypes,
  ...OfferSourcingDocumentTypes,
  ...OfferBookingDocumentTypes,
  REPLY_SUPPORT_DOCUMENT: 'REPLY_SUPPORT_DOCUMENT',
  ANNOUNCEMENT_DOCUMENT: 'ANNOUNCEMENT_DOCUMENT',
  EXTERNAL_USER_MANUAL: 'EXTERNAL_USER_MANUAL',
  INTERNAL_USER_MANUAL: 'INTERNAL_USER_MANUAL',
}

export const newSubSystem = {
  projectName: '',
  existingContractInfo: {},
  renewContractInfo: {},
  internalCostSheet: [],
  bookingCostSheet: [],

  system: [
    {
      type: '',
      subType: '',
    },
  ],
  totalContractPrice: {
    currentContract: {
      month: 0,
      monthlyPrice: 0,
      startDate: undefined,
      endDate: undefined,
      total: 0,
      totalHKD: 0,
      grossMargin: 0,
      lastMonthPrice: 0,
    },
    newContractRows: [],
    grossMargin: 0,
  },
  SLA: {
    equipments: [],
    questionnaire: {},
  },
  costStructure: {
    GC_BAU: 0,
    GC_FS: 0,
    GC_OTHER: 0,
    material: 0,
    internalLabour: 0,
    internalLabourPercentage: 0,
    subcontractor: 0,
    freelancer: 0,
    other: 0,
    otherExpense: 0,
    misc: 0,
  },
}
export const OfferBookingStatus = {
  BOOKING_DRAFT: 'Booking Draft',
  BOOKING_SUBMITTED: 'Booking Submitted',
  BOOKING_REJECTED: 'Booking Rejected',
  BOOKING_COMPLETED: 'Booking Completed',
}

export const OfferStage = {
  QUOTATION: 'quotation',
  BOOKING: 'booking',
}

export const OfferQuotationStatus = {
  QUOTATION_DRAFT: 'Quotation Draft',
  QUOTATION_SUBMITTED: 'Pending Contributor Approval',
  QUOTATION_REVIEWED: 'Pending Approver Approval',
  QUOTATION_REJECTED: 'Approver Rejected',
  QUOTATION_APPROVED: 'Pending Upload',
  QUOTATION_COMPLETED: 'Submitted to Client',
}

export const OfferControlStatus = {
  // LOST: 'Lost',
  // DELETED: 'Deleted',
  // CLOSED: 'Closed',
  SUPERSEDED: 'Superseded',
  AWARDED: 'Awarded',
}
export const OfferStatus = {
  ...OfferQuotationStatus,
  ...OfferBookingStatus,
  ...OfferControlStatus,
}

export const ContributorStatus = {
  REQUIRED: 'Action Required',
  REVIEWED: 'Reviewed',
  COMMENTED: 'Commented',
}

export const ApprovalStatus = {
  UPCOMING: 'Upcoming',
  REQUIRED: 'Action Required',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
}

export const PRApprovalStatus = {
  ...ApprovalStatus,
  PARKED: 'On Hold',
}

export const ApprovalInvitationStatus = {
  INVITED: 'Invited',
  REPLIED: 'Replied',
  NOT_REQUIRED: 'Not Required',
}

export const BookingApproverRole = {
  TECHNICAL: 'technical',
  COMMERCIAL: 'commercial',
  LEGAL: 'legal',
  TECHNICAL_PROJECT_MANAGER: 'technicalProjectManager',
  COMMERCIAL_PROJECT_MANAGER: 'commercialProjectManager',
  QS: 'qs',
  OTHER: 'other',
}

export const RoleInOffer = {
  INITIATOR: 'Sales Responsible',
  DEPT_USER: 'Same Team User',
  CREATOR: 'Creator',
  CONTRIBUTOR_LEGAL: 'Contributor - Legal',
  CONTRIBUTOR_QS: 'Contributor - Quantity Surveyor',
  CONTRIBUTOR_OTHER: 'Contributor',
  TECHNICAL_PROJECT_MANAGER: 'Contributor - Technical Project Manager',
  COMMERCIAL_PROJECT_MANAGER: 'Contributor - Commercial Project Manager',
  PROCUREMENT_OFFICER: 'Procurement Officer',
  OPTIONAL_CONTRIBUTOR: 'Optional Contributor',

  QUOTATION_APPROVER: 'Quotation Approver',
  QUOTATION_APPROVER_DELEGATEE: "Quotation Approver's Delegatee",
  QUOTATION_APPROVER_INVITEE: "Quotation Approver's Invitee",
  BOOKING_APPROVER: 'Booking Approver',
  BOOKING_COMMERCIAL_PROJECT_MANAGER: 'Booking Commercial Project Manager',
  BOOKING_APPROVER_DELEGATEE: "Booking Approver's Delegatee",
  BOOKING_APPROVER_INVITEE: "Booking Approver's Invitee",
  GCPR_APPROVER_INVITEE: "GCPR Approver's Invitee",
  TEAM_ASSISTANT: 'Team Assistant',
  ENGINEER: 'Engineer',
  MANAGER: 'Manager',
  BOOKING_MANAGER: 'Booking Manager',
  PR_APPROVER: 'PR Approver',
  PR_APPROVER_DELEGATEE: "PR Approver's Delegatee",
  GCPR_APPROVER: 'GCPR Approver',
  GCPR_APPROVER_DELEGATEE: "GCPR Approver's Delegatee",
}

export const OfferType = {
  MAINTENANCE: 'maintenance',
  PROJECT: 'project',
}

export const Currency = {
  HKD: 'HKD',
  MOP: 'MOP',
  USD: 'USD',
  EUR: 'EUR',
  CNY: 'CNY',
}

export const MaintenanceSummaryStatus = {
  NOT_STARTED: 'notStarted',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  RENEWAL_LOST: 'renewalLost',
  RENEWED: 'renewed',
  NOT_COMPLETED: 'notCompleted',
}

export const OfferPaymentCreditTerm = {
  A000: 'A000',
  A014: 'A014',
  A030: 'A030',
  A045: 'A045',
  A060: 'A060',
  A090: 'A090',
}

export const OfferApprovalType = {
  CONTRIBUTION_REVIEW: 'Review',
  OPTIONAL_CONTRIBUTION_REVIEW: 'Optional Contributor Review ',
  CONTRIBUTION_COMMENT: 'Comment',
  QUOTATION_APPROVE: 'Approve Quotation',
  QUOTATION_REJECT: 'Reject Quotation',
  BOOKING_APPROVE: 'Approve Booking',
  BOOKING_REJECT: 'Reject Booking',
  PR_APPROVE: 'Approve PR',
  PR_REJECT: 'Reject PR',
  PR_ON_HOLD: 'On Hold PR',
}
